import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      <style>
        {`
          @media (max-width: 758px) {
            .smsc-h {
              height: 1100px !important;
            }
          }
          @media (max-width: 658px) {
            .smsc-h {
              height: 1300px !important;
            }
          }
          
          @media (max-width: 458px) {
            .smsc-h {
              height: 1500px !important;
            }
          }

          @media (max-width: 370px) {
            .smsc-h {
              height: 1650px !important;
            }
          }

          @media (max-width: 340px) {
            .smsc-h {
              height: 1750px !important;
            }
          }
          
        `}
      </style>
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">KNOW HOW</p>
          <h2 className="text-3xl md:text-4xl font-bold">Experience</h2>
        </div>
        <div className="smsc-h mt-3 lgl:mt-6 w-full h-[900px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
        <ResumeCard
            title="Full Stack Engineer"
            subTitle="DevAmaze"
            result="Aug(2025)-Present"
            des="Architected and operated a fully automated SEO content pipeline, publishing 50+ articles per day from keyword research to AI generation, approvals, WordPress publishing, social distribution, and reporting.

Built scalable, event-driven automation using Node.js, TypeScript, BullMQ, and Redis, achieving a 98% background job success rate with retries and failure recovery.

Reduced manual content operations by 95% through end-to-end automation with scheduled daily runs and approval gating.

Improved content publishing speed by 80%+ by replacing manual workflows with automated AI generation and publishing pipelines.

Managed production automation infrastructure using Docker and background workers with monitoring across the full content lifecycle."
          />
        <ResumeCard
            title="Python Developer Intern"
            subTitle="DevAmaze"
            result="Mar(2025)-June(2025)"
            des="Built and optimized multiple web scraping tools to extract structured data from real estate, automotive, and business websites. I implemented smart solutions to handle rate limiting, IP blockage, and JavaScript-heavy pages using proxy rotation, request throttling, and headless browsers. Where available, I integrated APIs for more efficient and reliable data retrieval. My focus was on writing clean, modular code with strong error handling, ensuring robust and scalable scraping systems while improving data accuracy, efficiency, and reliability across all projects."
          />
          <ResumeCard
            title="Web Developer"
            subTitle="STO UAF"
            result="May(2024)-June(2025)"
            des="Developed and maintained Stouaf.com, the university’s official platform for student societies, enabling event management, memberships, and success story sharing. Collaborated with coordinators to create responsive, user-friendly interfaces and implemented a centralized participation database to boost engagement and streamline operations."
            />
          
        </div>
      </div>
        
    </motion.div>
  );
};

export default Experience;
